import { Box, HTMLWrapper, Stack } from "@/storybook-components";
import type { Question } from "@/types";

interface SectionQuestionProps {
  question: Question;
}

const SectionQuestion = ({ question }: SectionQuestionProps): JSX.Element => {
  return (
    <Stack spacing={1}>
      <HTMLWrapper
        html={question.question}
        className="ehq-surveyQuestionHeading"
        fontSize="1.5rem"
        lineHeight="123.5%"
        fontWeight="bold"
        color="gray.800"
      />
      <Box className="ehq-sectionQuestion">
        <HTMLWrapper html={question.descriptor} />
      </Box>
    </Stack>
  );
};

export default SectionQuestion;
